<template>
  <div>
    <treeselect
      ref="treeselect"
      v-model="selected"
      multiple
      :always-open="tags_filter_opened"
      :options="treeOptions"
      :placeholder="treeTitle"
      :disabled="disabled || busy"
      :before-clear-all="onBeforeClearAll"
      :clearable="false"
      :close-on-select="false"
      disable-fuzzy-matching
      @close="onClose"
      class="class-multiselect"
    >
      <div slot="before-list">
        <b-row class="border-bottom">
          <b-col class="font-italic">
            <a class="ml-2" href="#" @click.prevent="onTreeSelectAll">
              <small>{{ trans('select_all') }}</small>
            </a>
          </b-col>
          <b-col class="font-italic">
            <a class="mr-2" href="#" @click.prevent="onTreeClearAll">
              <small>{{ trans('unselect_all') }}</small>
            </a>
          </b-col>
          <b-col class="text-right tags-container mr-2">
            <tags-filter
              :organization="organization"
              multiple
              multiple-not-lazy
              allow-none
              v-model="tags"
              type="class"
              right
              boundary="body"
              toggle-class="py-0"
              no-flip
              :is-none="tag_is_none"
              @is-none="tag_is_none = $event"
              :all-tags="all_tags"
              @all-tags="all_tags = $event; $emit('all-tags', $event)"
              @show="onTagsShow"
              @hidden="onTagsHidden"
            ></tags-filter>
          </b-col>
        </b-row>
      </div>
      <div slot="option-label" slot-scope="{ node }">
        <span>
          {{ node.label }}
          <small v-if="node.raw.start" class="text-muted">
            {{ moment(node.raw.start).format('ddd LLL') }}
          </small>
          <small v-if="node.raw.attendance" class="text-muted">
            ({{ node.raw.attendance }})
          </small>
          <sup v-if="node.raw.tags.length > 0">
            <b-badge
              variant="tag"
              class="mr-1"
              v-for="tag in node.raw.tags"
              :key="tag"
            >
              {{ tag }}
            </b-badge>
          </sup>
        </span>
      </div>
    </treeselect>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import Tags from './../tag/Tags'
  import TagsFilter from './../tag/TagsFilter'

  export default {
    props: {
      organization: Object,
      value: Array,
      disabled: {
        type: Boolean,
        default: false,
      },
      requestOnTagsChange: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: trans('choose_a_class_event'),
      },
      allClasses: Array,
      allTags: Array,
      onlyAmClasses: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Treeselect,
      Tags,
      TagsFilter,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        selected: this.value ? _.clone(this.value) : [],
        all_classes: this.allClasses,
        all_tags: this.allTags,
        // filter
        tags: [],
        tag_is_none: false,
        tags_filter_opened: false,
      }
    },
    computed: {
      treeTitle() {
        return !this.isLoading ? trans('select_classes') : trans('please_wait')
      },
      treeOptions() {
        return _.reduce(this.all_classes || [], (options, cls) => {
          let attendance = null
          if (cls.participant_count > 0 && cls.maximum_attendance > 0 || cls.maximum_attendance > 0) {
            attendance = `${cls.participant_count || 0}${cls.maximum_attendance > 0 ? (' / ' + cls.maximum_attendance) : ''}`
          }
          let tags = _.map(cls.tags, 'name')
          //if (!this.tag || tags.indexOf(this.tag) >= 0) {
          if (this.tags.length == 0 && !this.tag_is_none || this.tags.length == 0 && this.tag_is_none && tags.length == 0 || this.tags.length > 0 && _.intersection(tags, this.tags).length == this.tags.length) {
            options.push({
              id: cls.id,
              label: cls.name,
              attendance: attendance,
              start: cls.start,
              tags: tags,
            })
          }
          return options
        }, [])
      },
      participantCount() {
        return _.reduce(this.all_classes || [], (count, cls) => {
          if ((this.selected || []).indexOf(cls.id) >= 0)
            count += cls.participant_count
          return count
        }, 0)
      },
      classCount() {
        return _.reduce(this.all_classes || [], (count, cls) => {
          if ((this.selected || []).indexOf(cls.id) >= 0)
            count += 1
          return count
        }, 0)
      },
    },
    watch: {
      allClasses() {
        this.all_classes = this.allClasses
      },
      allTags() {
        this.all_tags = this.allTags
      },
      value() {
        this.selected = this.value ? _.clone(this.value) : []
      },
      tags() {
        if (this.requestOnTagsChange) {
          this.fetch().then(response => {
            this.tags_filter_opened = true
          })
        }
      }
    },
    methods: {
      // Three methods to prevent closing the treeselect when using the tags dropdown filter
      onTagsShow() {
        this.tags_filter_opened = true
        let menu_el = this.$refs.treeselect.$el.querySelector('.tags-container')
        menu_el.addEventListener('mousedown', this.onTreeselectMenuMousedown)
      },
      onTreeselectMenuMousedown(e) {
        //e.preventDefault()
        e.stopImmediatePropagation()
        return false
      },
      onTagsHidden() {
        let menu_el = this.$refs.treeselect.$el.querySelector('.tags-container')
        menu_el.removeEventListener('mousedown', this.onTreeselectMenuMousedown)
        this.$nextTick(() => {
          this.tags_filter_opened = false
          this.$nextTick(() => {
            this.$refs.treeselect.openMenu()
          })
        })
      },
      onTreeSelectAll(index) {
        this.selected.splice(0, this.selected.length)
        let visibleIds = this.getSelectedOptionIds()
        this.treeOptions.forEach(option => {
          if (visibleIds.indexOf(option.id) >= 0) this.selected.push(option.id)
        })
      },
      getSelectedOptionIds() {
        let visibleIds = [];
        this.$refs
          .treeselect
          .$el.querySelectorAll('.vue-treeselect__option:not(.vue-treeselect__option--hide)')
          .forEach(el => {
            if (el && el.dataset && el.dataset.id) visibleIds.push(parseInt(el.dataset.id, 10))
          })
        return visibleIds
      },
      onTreeClearAll(index) {
        if (this.selected) this.selected.splice(0, this.selected.length)
      },
      onBeforeClearAll() {
        this.$nextTick(() => {
          this.$emit('input', [])
          this.$emit('participant-count', 0)
          this.$emit('class-count', 0)
        })
        return true
      },
      onClose() {
        if (!_.isEqual(this.selected, this.value)) {
          this.$emit('input', this.selected)
          this.$emit('participant-count', this.participantCount)
          this.$emit('class-count', this.classCount)
        }
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/event/ll`
        let params = {}
        if (this.requestOnTagsChange) params.tags = this.tags
        if (this.onlyAmClasses) params.type = 'am_event'
        return axios.get(url, {
          params: params
        })
        .then(response => {
          this.busy = false
          this.all_classes = response.data
          this.$emit('all-classes', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.classMultiselect = this
      if (this.all_classes == null) this.fetch()
    },
  }
</script>